import { useEffect, useState } from "react";
import { useActiveMatch } from "../../hooks/useActiveMatch";
import { useMatchFilters } from "../../hooks/useMatchFilters";
import { PlayerAutocomplete } from "../scores/PlayerAutocomplete";
import { MachineAutocomplete } from "../scores/MachineAutocomplete";
import { Button } from "@heroui/react";
import { SinglesOrDoublesFilter } from "./SinglesOrDoublesFilter";
import { PickOrRespondFilter } from "./PickOrRespondFilter";

export function MatchFilters() {
  const {
    selectedMachines,
    setSelectedMachines,
    selectedPlayers,
    setSelectedPlayers,
    singlesOrDoubles,
    setSinglesOrDoubles,
    pickOrRespond,
    setPickOrRespond,
  } = useMatchFilters();

  const { match } = useActiveMatch();

  const [playerPool, setPlayerPool] = useState(
    match.opponent__v2?.roster || []
  );

  const [machinePool, setMachinePool] = useState(match.machines);

  function resetFilters() {
    setSelectedPlayers(match.opponent__v2?.roster.map((p) => p.id) || []);
    setSelectedMachines(match.machines.map((m) => m.machineGroupId));
    setSinglesOrDoubles(["singles", "doubles"]);
    setPickOrRespond(["pick", "respond"]);
    setFiltersPopulated(false);
  }

  useEffect(() => {
    setPlayerPool(match.opponent__v2?.roster || []);
    setMachinePool(match.machines);
    resetFilters();
  }, [match]);

  const [filtersPopulated, setFiltersPopulated] = useState(false);

  useEffect(() => {
    const machineFilterPopulated =
      machinePool &&
      selectedMachines &&
      machinePool.length !== selectedMachines.length;

    const playerFilterPopulated =
      playerPool &&
      selectedPlayers &&
      playerPool.length !== selectedPlayers.length;

    const singlesOrDoublesFilterPopulated = !(
      Array.isArray(singlesOrDoubles) &&
      singlesOrDoubles.length === 2 &&
      singlesOrDoubles.includes("singles") &&
      singlesOrDoubles.includes("doubles")
    );

    const pickOrRespondFilterPopulated = !(
      Array.isArray(pickOrRespond) &&
      pickOrRespond.length === 2 &&
      pickOrRespond.includes("pick") &&
      pickOrRespond.includes("respond")
    );

    const filtersPopulated =
      machineFilterPopulated ||
      playerFilterPopulated ||
      singlesOrDoublesFilterPopulated ||
      pickOrRespondFilterPopulated;

    setFiltersPopulated(filtersPopulated);
  }, [
    machinePool,
    selectedMachines,
    selectedPlayers,
    singlesOrDoubles,
    pickOrRespond,
  ]);

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex w-full flex-col gap-4 md:flex-row md:items-start">
          <PlayerAutocomplete
            players={playerPool}
            selectedPlayers={selectedPlayers}
            setSelectedPlayers={setSelectedPlayers}
          />
          <MachineAutocomplete
            machines={machinePool}
            selectedMachines={selectedMachines}
            setSelectedMachines={setSelectedMachines}
          />
        </div>
        <SinglesOrDoublesFilter
          singlesOrDoubles={singlesOrDoubles}
          setSinglesOrDoubles={setSinglesOrDoubles}
        />
        <PickOrRespondFilter
          pickOrRespond={pickOrRespond}
          setPickOrRespond={setPickOrRespond}
        />
      </div>

      {filtersPopulated && (
        <Button className="w-20" color="danger" onPress={resetFilters}>
          Reset
        </Button>
      )}
    </div>
  );
}
